import styled from "styled-components"

export interface StyledFixedHeaderProps {
  background_color: string
}

export const StyledFixedHeaderContainer = styled.div`
  margin-top: 98px;
`

export const StyledFixedHeaderWrapper = styled.div<StyledFixedHeaderProps>`
  padding: 16px 0;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  width: 100%;
  box-shadow: rgba(44, 44, 44, 0.15) 0px 0px 16px;

  background: ${(props) =>
    props.background_color === "white" && props.theme.colors.white};
  background: ${(props) =>
    props.background_color === "ivory" && props.theme.colors.ivory};
  background: ${(props) =>
    props.background_color === "ivory_dark" && props.theme.colors.ivoryShadow};
  background: ${(props) =>
    props.background_color === "charcoal" && props.theme.colors.darkGrey};
  ${(props) =>
    props.background_color === "transparent" &&
    "background: transparent; box-shadow: none;"};
`

export const StyledFixedHeader = styled.div`
  ${(props) => props.theme.mixins.container}
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledLogo = styled.a`
  & img {
    height: 64px;
  }

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: none;
  }
`
export const StyledMobileLogo = styled.a`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    display: none;
  }
  & img {
    height: 44px;
  }
`

export const StyledButton = styled.div``
